import { capitalize } from './capitalize'
import { firstLetterCapitalize } from './firstLetterCapitalize'
import { secondFormat } from './secondFormat'
import { minuteFormat } from './minuteFormat'

export default {
  capitalize,
  firstLetterCapitalize,
  secondFormat,
  minuteFormat
}
